import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledTextWrapper = styled.div`
  margin-bottom: 2rem;
`

export const StyledBankListWrapper = styled.div`
  display: grid;
  gap: 10px;
  ${({ isMobile }) => isMobile && 'grid-template-columns: repeat(2, 1fr)'}
`

export const StyledAlertWrapper = styled.div`
  margin-top: 1rem;
`
export const StyledSubheader = styled.p`
  color: ${themeStyles.colors.darkGreys[2].main};
  & strong {
    font-weight: 700;
  }
`

export const textStyles = {
  title: { fontSize: 20 },
  link: { color: '#000' },
  margin: { marginBottom: '40px', marginTop: '20px', fontSize: 14 },
}
